import { NgClass } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ARROWS } from '../../../../../shared/constants/arrows';

@Component({
  selector: 'app-chevron-icon',
  imports: [NgClass],
  templateUrl: './chevron-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chevron-icon.component.scss',
})
export class ChevronIconComponent {
  @Input() public direction = ARROWS.UP;
  @Input() public size = 4;

  public arrows = ARROWS;

  public getStateClass(): string {
    const rotateClass = this.direction === this.arrows.DOWN ? 'rotate-180 ' : '';
    return `${rotateClass}size-${this.size}`;
  }
}
